import { useQueryClient } from 'react-query';
import { useRouteMatch } from 'react-router-dom';
import { useEvent } from '../../../../../../../../hooks/useEvent';
import { getQueryKeys } from '../../../../../../queries/queryKeys';

const getId = (value) => {
  const id = Number(value);

  return !isNaN(id) ? id : undefined;
};

export const useInvalidateFlatsGrid = () => {
  const queryClient = useQueryClient();

  const { params } = useRouteMatch();

  const houseId = getId(params.pageId);

  return useEvent(() => {
    queryClient.invalidateQueries(getQueryKeys.flatsGrid(houseId));
  });
};
